"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgBtChart = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgBtChart = function SvgBtChart(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.5614 19.9473C8.33918 16.5789 12.1474 9.89822 13.1579 10.1228C14.4211 10.4035 16.2456 12.6491 17.3684 12.6491C18.4912 12.6491 21.5789 9 22 9M22 14.8947C20.7836 15.924 18.2105 17.9825 17.6491 17.9825C16.9474 17.9825 12.3158 14.3333 11.614 14.3333M8.5 13.2105C7.9386 12.883 7.01053 12.6491 6 13.2105",
    stroke: "currentColor",
    strokeLinecap: "round"
  }));
};

exports.SvgBtChart = SvgBtChart;